import { apiClient } from 'api/client/apiClient';
import { DeleteApplicationParams } from '../types';
import { API_URLS } from '../consts';

export const deleteApplication = async ({ id }: DeleteApplicationParams) => {
  const result = await apiClient.delete(`${API_URLS.Applications}/applications/${id}`);

  return result.data;
};
